
import { useState, useCallback,useMemo, useEffect } from 'react'
import axios from 'axios'
import auth from "../auth/auth"
import {useHistory} from "react-router-dom";
import { ValidateLocalStorageToken, DC_ROLES } from '../constants/provider/constant';

const _axios =(config)=>{
  let user = ValidateLocalStorageToken(localStorage.getItem("user_details")) && JSON.parse(localStorage.getItem("user_details"))
  let configData = config;
  configData.data = {
    ...config.data,
    "appId":10007,
    "requestAccessToken": ValidateLocalStorageToken(localStorage.getItem("access_token")) && JSON.parse(localStorage.getItem("access_token")),
  }
  if(user?.entityType == "DC" || DC_ROLES.includes(user?.role)){
    configData.data = {
      ...config.data,
      "appId":10007,
      "providerId":user.providerId,
      "requestAccessToken": ValidateLocalStorageToken(localStorage.getItem("access_token")) && JSON.parse(localStorage.getItem("access_token")),
      "deviceName": window.deviceId,
    }
    if(user?.parentProvider?.isParent ?? false){
      let data =  
      user ?
        ( user?.parentProvider?.isParent ? 
          ( user.selectedProviders && user.selectedProviders.length !== 0 ? user.selectedProviders : Object.keys(user.parentProvider.childEntities) ) 
        : null )
      : null

      configData.data.providerList = data.filter(function( element ) {
      return element != "undefined";
      });
    }
  }
  if(user?.entityType == "Insurer"){
    configData.data = {
      ...config.data,
      "appId":10007,
      "insUser": user.userEmail,
      "clientName":user.entityName,
      "userId": user.userId,
    }
    if(user?.parentProvider?.isParent ?? false){
      configData.data.corporateIDs =  
      user ?
        ( user?.parentProvider?.isParent ? 
          ( user.selectedProviders && user.selectedProviders.length !== 0 ? user.selectedProviders : user?.corporateIDs ) 
        : null )
      : null
    }
  }
  if(user?.role === "Insurer_Agent"){
    configData.data = {
      ...config.data,
      "appId":10007,
      "insUser": user.userEmail,
      "clientName":user.entityName,
      "userId": user.userId,
      "agentId": user.properties.AgentId,
    }
  }
  return axiosFinal(configData)
  .then(response=>{
    console.log(response)
    if( response && response.data &&( response.data.error === "Invalid Access Token" || response.data.ErrorMessage === "Invalid Access Token" )){
      localStorage.removeItem("access_token")
      localStorage.setItem("tokenExpired", "true")
      return response
    }else{
      return response;
    }
  });
} 
const axiosFinal = axios.create(); 

const useAxiosLoader = () => {
  const [counter, setCounter] = useState(0);
  const inc = useCallback(() => setCounter(counter => counter + 1), []);
  const dec = useCallback(() => setCounter(counter => counter - 1), []);
  const history = useHistory();
  const logout = () => {
    auth.logout(()=>{
      localStorage.clear()
      localStorage.setItem("tokenExpired", "true")
      history.push("/login")
    })
  }
  const interceptors = useMemo(() => ({
    request: config => {inc(); return config},
    response: response => {
      dec();
      if( response && response.data &&( response.data.error === "Invalid Access Token" || response.data.ErrorMessage === "Invalid Access Token" )){
        logout();
        return response;
      }else{
        return response;
      }
    },
    error: async error => {
      dec();
      if(error && (error.data?.error === "Invalid Access Token" || error.response && error.response.data && error.response.data?.ErrorMessage === "Invalid Access Token")){
        logout();
      }
      return Promise.reject(error);
    },
  }), [inc, dec]); 
  
  useEffect(()=>{
    //used for token Expired refresh page
    if(!localStorage.getItem("access_token")){
      history.push("/login")
    }
  })

  useEffect(() => {
    const reqInterceptor = axiosFinal.interceptors.request.use(interceptors.request, interceptors.error);
    const resInterceptor =  axiosFinal.interceptors.response.use(interceptors.response, interceptors.error);
    return () => {
      axiosFinal.interceptors.request.eject(reqInterceptor);
      axiosFinal.interceptors.response.eject(resInterceptor);
    };
  }, [interceptors]);
  return [counter > 0];
};
  
export {
  _axios,
  axiosFinal,
  useAxiosLoader
}